import { useQuery } from '@tanstack/react-query';
import { projectService } from '@services/project';

export const PROJECT_QUERY_KEY = 'project';

export const useProject = (projectId?: string) => {
  return useQuery({
    queryKey: [PROJECT_QUERY_KEY, projectId],
    queryFn: () => projectService.getProjectById(projectId!),
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry if project is not found
      if (error?.message === 'Project not found') {
        return false;
      }
      return failureCount < 3;
    },
  });
};
